import React from 'react';

/**
 * Renders the icon frame experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.children - Nested content rendered by the component.
 * @param {*} props.className - class name value.
 * @returns {JSX.Element} The rendered interface.
 */
function IconFrame({ children, className = '' }) {
  return (
    <svg
      aria-hidden="true"
      className={`action-icon-svg ${className}`.trim()}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

/**
 * Renders the camera icon experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.className - class name value.
 * @returns {JSX.Element} The rendered interface.
 */
export function CameraIcon({ className }) {
  return (
    <IconFrame className={className}>
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z" />
      <circle cx="12" cy="13" r="3" />
    </IconFrame>
  );
}

/**
 * Renders the pencil icon experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.className - class name value.
 * @returns {JSX.Element} The rendered interface.
 */
export function PencilIcon({ className }) {
  return (
    <IconFrame className={className}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </IconFrame>
  );
}
